import { SideEffectFunction } from '../../../sideEffects';
import { CORE_API_HOSTNAME } from '../../../env';
import fulfill from '../../../fulfill';
import { ActionTypes, FetchDiscountsResponse, FetchNextResponse, GetDiscounts, GetDiscountsReason } from './actions';
import { Discount } from '../../../types/discounts';

const fetchNext: SideEffectFunction<FetchDiscountsResponse, FetchNextResponse | undefined> = async (action) => {
    if (action.meta.cause.payload.reason === GetDiscountsReason.refresh) {
        return;
    }

    const hasLimitInParams = action.meta.cause.payload.params.get('limit');
    const isAtLastPage = hasLimitInParams
        ? action.payload.discounts.length < parseInt(hasLimitInParams)
        : action.payload.discounts.length === 0;

    if (isAtLastPage) {
        return {
            type: ActionTypes.FetchNextResponse,
            payload: {
                discounts: [],
            },
            meta: {
                cause: action,
            },
        };
    }

    const params = action.meta.cause.payload.params;
    const lastDiscount = action.payload.discounts[action.payload.discounts.length - 1];
    params.delete('starting_after');
    // @ts-ignore
    if (lastDiscount && lastDiscount.ref_id) {
        // @ts-ignore
        params.append('starting_after', lastDiscount.ref_id);
    }
    params.delete('limit');
    params.append('limit', '1');

    const result: FetchNextResponse = await fulfill.get({
        accountId: action.meta.cause.payload.accountId,
        url: `${CORE_API_HOSTNAME}/v1/accounts/${action.meta.cause.payload.accountId}/discounts/customers/${action.meta.cause.payload.id}/rules?${params.toString()}`,
        handlers: {
            200: (discounts: Discount[]) => ({
                type: ActionTypes.FetchNextResponse,
                payload: {
                    discounts: discounts,
                },
                meta: {
                    cause: action,
                },
            }),
        },
    });
    return result;
};

const fetchDiscounts: SideEffectFunction<GetDiscounts, FetchDiscountsResponse> = async action => {
    const { accountId, id, params } = action.payload;
    const result: FetchDiscountsResponse = await fulfill.get({
        accountId,
        url: `${CORE_API_HOSTNAME}/v1/accounts/${accountId}/discounts/customers/${id}/rules?${params.toString()}`,
        handlers: {
            200: (discounts: Discount[]) => ({
                type: ActionTypes.FetchDiscountsResponse,
                payload: {
                    discounts: discounts,
                },
                meta: {
                    cause: action,
                },
            }),
            400: () => ({
                type: ActionTypes.FetchDiscountsResponse,
                payload: {
                    discounts: [],
                },
                meta: {
                    cause: action,
                },
            }),
        },
    });
    return result;
};

const effects = {
    [ActionTypes.GetDiscounts]: fetchDiscounts,
    [ActionTypes.FetchDiscountsResponse]: fetchNext,
};

export default effects;

